export default __webpack_public_path__ + "static/media/404error.63c7b6a1.jpg";